import React from 'react';
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const HomeView = () => {
  const textColor = useColorModeValue('gray.800', 'white');
  const accentColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <Container maxW="container.xl" py={10}>
      <VStack spacing={10} align="center">
        <Heading 
          as="h1" 
          size="2xl" 
          color={textColor}
          textAlign="center"
          lineHeight="1.2"
        >
          Welcome to <Text as="span" color={accentColor}>Aigent</Text>
        </Heading>
        
        <Text fontSize="xl" color={textColor} textAlign="center" maxW="800px">
          Your intelligent assistant for managing tasks, organizing information, and boosting productivity.
        </Text>
        
        <Stack 
          direction={{ base: 'column', md: 'row' }} 
          spacing={6}
          pt={6}
        >
          <Button
            as={RouterLink}
            to="/login"
            colorScheme="blue"
            size="lg"
            height="60px"
            px={8}
            fontSize="lg"
          >
            Sign In
          </Button>
          
          <Button
            as={RouterLink}
            to="/register"
            colorScheme="teal"
            size="lg"
            height="60px"
            px={8}
            fontSize="lg"
            variant="outline"
          >
            Create Account
          </Button>
        </Stack>
        
        <Box pt={16} w="100%">
          <Flex 
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
            gap={8}
          >
            <Feature 
              title="Smart Organization" 
              description="Organize your tasks and information intelligently with AI-powered categorization."
            />
            <Feature 
              title="Secure Authentication" 
              description="Your data is protected with our secure authentication system."
            />
            <Feature 
              title="Responsive Design" 
              description="Access your account from any device with our responsive interface."
            />
          </Flex>
        </Box>
      </VStack>
    </Container>
  );
};

const Feature = ({ title, description }) => {
  const bgColor = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Box
      p={6}
      bg={bgColor}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      boxShadow="md"
      flex="1"
      minH="200px"
    >
      <Heading as="h3" size="md" mb={4} color={textColor}>
        {title}
      </Heading>
      <Text color={textColor}>
        {description}
      </Text>
    </Box>
  );
};

export default HomeView;
